<!-- group.component.html -->
@if (componentInitialized && !isSingleUserAcc) {
    <p-selectButton
        data-testid="team-view-toggle"
        [allowEmpty]="false"
        [options]="stateOptions"
        (onChange)="toggleState($event.value)"
        [(ngModel)]="selectedView"
    />
}

<div class="mt-6">
    @if (selectedView === "members") {
        <app-members (updateParent)="handleUpdate()" />
    } @else if (selectedView === "groups") {
        <app-group />
    }
</div>
